define( function() {
	"use strict";

	return [];
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/arr.js
// module id = 62
// module chunks = 27